import { implementCustomExpressions } from '../__generated/implementation.js';
import { createCamlockHolePolygon } from '../polygons/camlock-hole.js';
const sizeTolerance = {
    x: 1,
    y: 1
};
export const camlockHoleExpressions = implementCustomExpressions({
    CamlockHole: {
        $sizeX: (self)=>self.width,
        $sizeY: (self)=>self.height,
        $innerSize: (self)=>self.width / 2,
        $sizeTolerance: ()=>sizeTolerance,
        $polygons: (self)=>[
                createCamlockHolePolygon(self)
            ]
    }
});

//# sourceMappingURL=camlock-hole.js.map